// BUG-O11 · MG-ILE-919 · El acuse de la autoridad se pinta IGUAL en el expediente, en «Estado
// del trámite» y en la carta de notificación.
//
// Observación O-11 de QA (29-sep-2026): del mismo caso, la bandeja y la carta decían «Acuse
// demorado» y el trámite y el expediente «Acuse pendiente». Cada pantalla traducía el acuse a
// su manera: el expediente con un ternario sobre `estado_cargo`, el trámite con el glosario de
// ese mismo código guardado y la carta comparando el texto para elegir el color. Ahora las tres
// usan esta insignia, que pinta el TEXTO QUE MANDA EL SERVIDOR (`texto_del_acuse`: «Acuse
// pendiente», «Acuse demorado», «Cargo recibido · dd/mm/aaaa») y solo elige el tono con el
// glosario (`tonoDelAcuse`: `acuse_demorado` del contrato y el código del cargo). Ni cuenta
// días ni compone el texto.
//
// Especificación: `05_analisis_tecnico/Farmacovigilancia/ui/MG-ILE-54.md`, fila «Acuse de la
// autoridad» y tabla ## Coherencia. Texto e ícono, nunca solo color (RNF-11, WCAG 1.4.1).

import { CheckCircle2, Hourglass } from 'lucide-react';
import { StatusBadge } from './ui';
import type { Icono, Tono } from './ui';
import { tonoDelAcuse } from '../lib/etiquetas';

/** Lo que el contrato trae del acuse: el trámite y la notificación del expediente lo comparten. */
export interface AcuseDelServidor {
  texto_del_acuse: string | null;
  acuse_demorado: boolean;
  estado_cargo: string | null;
}

/** El ícono acompaña al tono: el cargo recibido se marca como hecho; lo demás es espera. */
const ICONO_DEL_TONO: Partial<Record<Tono, Icono>> = { success: CheckCircle2 };

export default function EstadoDelAcuse({ acuse }: Readonly<{ acuse: AcuseDelServidor }>) {
  if (!acuse.texto_del_acuse) return null;
  const tono = tonoDelAcuse(acuse.estado_cargo, acuse.acuse_demorado);
  return (
    <StatusBadge tone={tono} icon={ICONO_DEL_TONO[tono] ?? Hourglass}>
      {acuse.texto_del_acuse}
    </StatusBadge>
  );
}
